/*
 * core.js — vanilla, defer, lädt überall (Budget klein halten).
 * P0: Header-Shrink, Reveal-on-Scroll (.rv), Live-Öffnungsstatus, Karten-Tilt.
 * Drawer/Cart/Predictive Search folgen in P3/P4.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Die Kopfzeile schwebt und steht ausserhalb des Flusses. Ihre Hoehe haengt
     an Inhalt und Breite — deshalb wird sie gemessen und als --bar-total
     gesetzt, statt sie im CSS zu raten. Der Token bleibt als Startwert. */
  (function () {
    var wrap = document.querySelector('.ph-brand-wrap');
    if (!wrap) return;
    var tabs = document.querySelector('.ph-tabs');
    /* Die Ankuendigungsleiste steht im Fluss ganz oben. Die angedockte
       Kopfzeile schwebt darueber und haette sie verdeckt — also faengt sie
       unter ihr an. Beim Scrollen faellt das weg, dann loest sich die
       Kopfzeile ohnehin zur Pille. */
    var ann = document.querySelector('.announcement');
    var sync = function () {
      document.documentElement.style.setProperty('--ann-h',
        (ann ? Math.round(ann.getBoundingClientRect().height) : 0) + 'px');
      var r = wrap.getBoundingClientRect();
      /* Hoehe, nicht Unterkante: die Leiste sitzt beim Scrollen tiefer. Mit
         der Unterkante haette sich der Seitenanfang beim Scrollen verschoben. */
      if (r.height > 0) document.documentElement.style.setProperty('--bar-total', Math.round(r.height + 14) + 'px');
      /* Die Tab-Leiste ist hoeher als der reine Token: Innenabstand und der
         sichere Bereich am unteren Rand kommen dazu. Ungemessen schob sich die
         Kauf-Leiste auf der Produktseite darunter. */
      if (tabs) {
        /* Die Leiste schwebt mit Abstand zum unteren Rand. Gebraucht wird
           der ganze Streifen, den sie belegt: Hoehe plus dieser Abstand. */
        var ts = getComputedStyle(tabs);
        var th = ts.display === 'none' ? 0 : Math.round(tabs.getBoundingClientRect().height + (parseFloat(ts.bottom) || 0));
        document.documentElement.style.setProperty('--tabs-h', th + 'px');
      }
    };
    sync();
    /* Die drei Leisten aendern ihre Hoehe auch ohne Fenstergroesse: die
       Ankuendigung kann wegfallen, die Pille umbrechen. Ein ResizeObserver
       zieht die Masse nach, statt sie einmal zu raten. */
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(sync);
      [wrap, tabs, ann].forEach(function (el) { if (el) ro.observe(el); });
    }
    addEventListener('resize', sync, { passive: true });
    addEventListener('load', sync, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync).catch(function () {});
  })();

  var header = document.querySelector('[data-header]');

  /* --- Formularmeldung nach dem Absenden anspringen ------------------
     Shopify-Formulare laden nach dem Absenden die Seite neu. Ohne das hier
     begann eine Vorlesehilfe wieder oben und erfuhr nicht, ob es geklappt
     hat. Die Meldung traegt data-form-meldung und tabindex=-1. */
  var meldung = document.querySelector('[data-form-meldung]');
  if (meldung) meldung.focus();

  /* --- Absenden sichtbar machen ------------------------------------
     Kontakt und Widerruf schickt Shopify selbst ab. Bei langsamer
     Verbindung passierte nach dem Klick sichtbar nichts, ein zweiter Klick
     schickte die Nachricht doppelt. Jetzt sagt der Knopf „Wird gesendet …"
     und jeder weitere Klick wird geschluckt. Bewusst aria-disabled statt
     disabled: ein gesperrter Knopf verliert den Fokus, und die Vorlesehilfe
     erfuhre den neuen Text nie. Kommt jemand per Zurueck auf die Seite
     (bfcache), gibt pageshow den Knopf wieder frei. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !f.hasAttribute('data-sendet')) return;
    if (f.getAttribute('aria-busy') === 'true') { e.preventDefault(); return; }
    var k = f.querySelector('button[type="submit"]');
    if (!k) return;
    k.dataset.vorher = k.innerHTML;
    k.textContent = 'Wird gesendet …';
    k.setAttribute('aria-disabled', 'true');
    f.setAttribute('aria-busy', 'true');
  });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('form[data-sendet][aria-busy]').forEach(function (f) {
      var k = f.querySelector('button[type="submit"]');
      if (k && k.dataset.vorher != null) { k.innerHTML = k.dataset.vorher; k.removeAttribute('aria-disabled'); }
      f.removeAttribute('aria-busy');
    });
  });

  /* --- Intro-Loader aufräumen (CSS blendet aus, JS entfernt nur das DOM) - */
  var loader = document.getElementById('ph-loader');
  if (loader) {
    if (document.documentElement.getAttribute('data-loader') === 'on') {
      window.setTimeout(function () {
        loader.remove();
        document.documentElement.removeAttribute('data-loader');
      }, 2600);
    } else {
      loader.remove();
    }
  }

  /* --- Header-Shrink beim Scrollen ----------------------------------- */
  /* Ganz oben angedockt, ab dem ersten Scrollen schwebende Pille. Das
     Attribut sitzt auf <html>, weil sowohl der Traeger als auch die Pille
     selbst darauf reagieren. */
  function onScroll() {
    var down = window.scrollY > 8;
    if (down) document.documentElement.setAttribute('data-scrolled', '');
    else document.documentElement.removeAttribute('data-scrolled');
    if (header) header.classList.toggle('is-scrolled', down);
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* --- Scroll-Fortschrittsbalken (oben) ------------------------------ */
  var progress = document.querySelector('[data-progress]');
  if (progress) {
    var pTick = false;
    var setProgress = function () {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      progress.style.transform = 'scaleX(' + (max > 0 ? (window.scrollY / max) : 0).toFixed(4) + ')';
      pTick = false;
    };
    setProgress();
    window.addEventListener('scroll', function () {
      if (!pTick) { pTick = true; requestAnimationFrame(setProgress); }
    }, { passive: true });
    window.addEventListener('resize', setProgress, { passive: true });
  }

  /* --- Reveal-on-Scroll (nach dem Loader, damit man es wirklich sieht) - */
  var loaderOn = document.documentElement.getAttribute('data-loader') === 'on';
  var reveals = document.querySelectorAll('.rv');
  if (reveals.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('in'); });
    } else {
      var startReveals = function () {
        // Auto-Stagger: aufeinanderfolgende .rv-Geschwister nacheinander einblenden
        reveals.forEach(function (el) {
          if (!el.style.getPropertyValue('--i') && el.parentElement) {
            var n = 0, sib = el.previousElementSibling;
            while (sib) { if (sib.classList && sib.classList.contains('rv')) n++; sib = sib.previousElementSibling; }
            if (n > 0) el.style.setProperty('--i', Math.min(n, 8));
          }
        });
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
        reveals.forEach(function (el) { io.observe(el); });
      };
      if (loaderOn) { window.setTimeout(startReveals, 1850); } else { startReveals(); }
    }
  }

  /* --- Headline Split-Reveal (Zeilen-Maske, Wort für Wort) ----------- */
  var splits = document.querySelectorAll('[data-split]');
  if (splits.length) {
    if (reduce) {
      splits.forEach(function (el) { el.style.opacity = '1'; });
    } else {
      splits.forEach(function (el) {
        var lines = el.innerHTML.split(/<br\s*\/?>/i);
        el.innerHTML = lines.map(function (line, li) {
          var ws = line.trim().split(/\s+/).filter(Boolean).map(function (w, i) {
            return '<span class="sr-w" style="--wi:' + i + '">' + w + '</span>';
          }).join(' ');
          return '<span class="sr-line" style="--li:' + li + '">' + ws + '</span>';
        }).join('');
        el.classList.add('sr-ready');
        el.style.opacity = '1';
      });
      window.setTimeout(function () {
        splits.forEach(function (el) { el.classList.add('sr-in'); });
      }, loaderOn ? 1900 : 120);
    }
  }

  /* --- Maskottchen antippen -> kurzer „Boop" -------------------------
     data-mascot markiert die Figur SELBST, es transportiert keinen Wert. Das
     war einmal anders: <phobos-product> trug die Bildadresse des Maskottchens
     im selben Attribut, und closest() fand auf jeder Produktseite dieses
     Element. Ein Tipp irgendwohin hat dann den ganzen Abschnitt um 1,1
     vergroessert und um fuenf Grad gedreht — das Dokument wurde auf einem
     390px-Schirm 674px breit, und die Seite rutschte seitlich weg.
     Die Adresse heisst jetzt data-mascot-src. Wer hier ein Attribut ergaenzt,
     sollte diese Trennung beibehalten. */
  if (!reduce) {
    document.addEventListener('click', function (e) {
      var m = e.target.closest && e.target.closest('[data-mascot]');
      if (!m) return;
      m.classList.add('is-poked');
      window.setTimeout(function () { m.classList.remove('is-poked'); }, 220);
    });
  }

  /* --- Animierte Zähler ---------------------------------------------- */
  var counters = document.querySelectorAll('[data-count]');
  if (counters.length) {
    var runCount = function (el) {
      var target = parseFloat(el.getAttribute('data-count')) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      if (reduce) { el.textContent = target + suffix; return; }
      var dur = 1400, t0 = null;
      var step = function (ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) {
      counters.forEach(runCount);
    } else {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { runCount(e.target); cio.unobserve(e.target); }
        });
      }, { threshold: 0.4 });
      counters.forEach(function (el) { cio.observe(el); });
    }
  }

  /* --- Live-Öffnungsstatus ------------------------------------------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var DAY = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  function parseRange(s) {
    if (!s) return null;
    var m = String(s).match(/(\d{1,2}):(\d{2})\s*[-–]\s*(\d{1,2}):(\d{2})/);
    if (!m) return null;
    return { o: +m[1] * 60 + +m[2], c: +m[3] * 60 + +m[4] };
  }

  function hm(m) { return pad((m / 60) | 0) + ':' + pad(m % 60); }

  /* Heute in Wuppertal, unabhaengig von der Uhr des Besuchers. */
  function berlinJetzt() {
    var p = {};
    new Intl.DateTimeFormat('en-US', {timeZone:'Europe/Berlin', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', hourCycle:'h23'})
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { y: +p.year, m: +p.month, d: +p.day, mins: +p.hour * 60 + +p.minute };
  }
  /* Tag „heute + plus" als Zahl JJJJMMTT (so liefert ihn Liquid) samt Wochentag. */
  function tagUm(h, plus) {
    var t = new Date(Date.UTC(h.y, h.m - 1, h.d + plus));
    return { key: t.getUTCFullYear() * 10000 + (t.getUTCMonth() + 1) * 100 + t.getUTCDate(), wd: t.getUTCDay() };
  }
  /* Zieht ein Zeitfenster aus den Oeffnungszeiten heraus — „früher
     Feierabend ab 16 Uhr" ist ein geschlossenes Fenster 16:00-19:00. */
  function abziehen(liste, weg) {
    var raus = [];
    liste.forEach(function (r) {
      if (weg.c <= r.o || weg.o >= r.c) { raus.push(r); return; }
      if (weg.o > r.o) raus.push({ o: r.o, c: weg.o });
      if (weg.c < r.c) raus.push({ o: weg.c, c: r.c });
    });
    return raus;
  }
  /* Oeffnungszeiten eines Tages: erst der Wochenplan, dann die Ausnahmen
     (Metaobjekt „Phobos · Sonderöffnungszeit"). „Geöffnet" mit Zeiten
     ersetzt den Tag, „Geschlossen" ohne Zeiten schliesst ihn ganz,
     „Geschlossen" mit Zeiten nimmt nur dieses Fenster heraus. */
  function zeitenAm(hours, ausnahmen, tag) {
    var regel = parseRange(hours[tag.wd]);
    var zeiten = regel ? [regel] : [];
    var hinweis = '', sonder = false;
    ausnahmen.filter(function (a) { return a.d === tag.key; })
      .sort(function (a, b) { return a.s < b.s ? -1 : 1; })   /* auf vor zu */
      .forEach(function (a) {
        var r = parseRange(a.z);
        sonder = true;
        if (a.n) hinweis = a.n;
        if (a.s === 'auf') { if (r) zeiten = [r]; }
        else zeiten = r ? abziehen(zeiten, r) : [];
      });
    return { r: zeiten, n: hinweis, sonder: sonder };
  }

  function statusZeigen(extra) {
  document.querySelectorAll('[data-open-status]').forEach(function (el) {
    var hours, ausnahmen = [];
    try { hours = JSON.parse(el.getAttribute('data-hours')); } catch (e) { return; }
    try { ausnahmen = JSON.parse(el.getAttribute('data-ausnahmen') || '[]'); } catch (e) { ausnahmen = []; }
    if (extra) ausnahmen = ausnahmen.concat(extra);
    var h = berlinJetzt();
    var heute = zeitenAm(hours, ausnahmen, tagUm(h, 0));
    var label = el.querySelector('.ostat__t') || el;
    var jetzt = null, spaeter = null;
    heute.r.forEach(function (r) {
      if (h.mins >= r.o && h.mins < r.c) jetzt = r;
      else if (h.mins < r.o && !spaeter) spaeter = r;
    });
    var zusatz = heute.n ? ' · ' + heute.n : '';
    var text;

    if (jetzt) {
      text = 'Jetzt geöffnet · bis ' + hm(jetzt.c) + zusatz;
    } else if (spaeter) {
      text = 'Geschlossen · öffnet heute ' + hm(spaeter.o) + zusatz;
    } else {
      var naechster = null;
      for (var i = 1; i <= 14 && !naechster; i++) {
        var t = tagUm(h, i), z = zeitenAm(hours, ausnahmen, t);
        if (z.r.length) naechster = { i: i, wd: t.wd, r: z.r[0] };
      }
      var anfang = heute.sonder && !heute.r.length ? 'Heute geschlossen' : 'Geschlossen';
      text = naechster
        ? anfang + zusatz + ' · öffnet ' + (naechster.i === 1 ? 'morgen' : DAY[naechster.wd]) + ' ' + hm(naechster.r.o)
        : 'Aktuell geschlossen' + zusatz;
    }
    el.classList.remove('open', 'closed');
    el.classList.add(jetzt ? 'open' : 'closed');
    label.textContent = text;
  });
  }
  statusZeigen();

  /* Ladenknopf: was heute spontan gesetzt wurde („jetzt zu", „spontan offen
     bis …"), steht in der Supabase-Tabelle laden_knopf — nicht im Theme, damit
     es ohne Shopify-Speichern und ohne Seiten-Cache sofort gilt. Geholt wird
     erst, wenn ein Status in Sichtweite kommt, und fuer eine Minute gemerkt:
     die meisten Seitenaufrufe fragen dadurch gar nicht nach. */
  (function () {
    var quelle = document.querySelector('[data-open-status][data-knopf]');
    if (!quelle || !window.fetch) return;
    function anwenden(z) {
      if (z && z.tag && z.zeiten) statusZeigen([{ d: +String(z.tag).replace(/-/g, ''), s: z.status, z: z.zeiten, n: z.hinweis || '' }]);
    }
    try {
      var gemerkt = JSON.parse(sessionStorage.getItem('ph_knopf') || 'null');
      if (gemerkt && Date.now() - gemerkt.t < 60000) { anwenden(gemerkt.z); return; }
    } catch (e) {}
    function holen() {
      fetch(quelle.getAttribute('data-knopf').replace(/\/$/, '') + '/rest/v1/laden_knopf?select=tag,status,zeiten,hinweis&id=eq.1',
        { headers: { apikey: quelle.getAttribute('data-knopf-key') } })
        .then(function (r) { return r.ok ? r.json() : []; })
        .then(function (zeilen) {
          var z = zeilen && zeilen[0] || null;
          try { sessionStorage.setItem('ph_knopf', JSON.stringify({ t: Date.now(), z: z })); } catch (e) {}
          anwenden(z);
        })
        .catch(function () {});
    }
    if (!('IntersectionObserver' in window)) { holen(); return; }
    var io = new IntersectionObserver(function (eintraege) {
      if (eintraege.some(function (e) { return e.isIntersecting; })) { io.disconnect(); holen(); }
    }, { rootMargin: '300px' });
    document.querySelectorAll('[data-open-status]').forEach(function (el) { io.observe(el); });
  })();

  /* --- Was gerade laeuft --------------------------------------------
     Eine Zeile im Fussbereich: „Riftbound-Locals starten in 20 Minuten",
     „Heute 13:30 · Reality Fracture Prerelease". Die Termine liefert Liquid
     in einem <template>, gerechnet wird hier — eine zwischengespeicherte
     Seite behauptete sonst stundenlang dasselbe. */
  var TAGE_LANG = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var LAEUFT = 240;  /* so lange nach Beginn gilt ein Termin als laufend */
  var BALD = 90;     /* ab hier wird in Minuten heruntergezaehlt */

  function startMinute(text) {
    var m = String(text || '').match(/(\d{1,2}):(\d{2})/);
    return m ? +m[1] * 60 + +m[2] : null;
  }

  function berlinUhr(datum) {
    return new Intl.DateTimeFormat('de-DE', {
      timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).format(datum);
  }

  document.querySelectorAll('[data-now-host]').forEach(function (host) {
    var link = host.querySelector('[data-now-playing]');
    var plan = host.querySelector('[data-now-plan]');
    if (!link || !plan || !plan.content) return;
    var label = link.querySelector('.ph-foot__now-t') || link;

    var teile = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Berlin', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    var p = {};
    teile.forEach(function (x) { p[x.type] = x.value; });
    var heute = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday);
    var jetzt = Number(p.hour) * 60 + Number(p.minute);
    if (heute < 0) return;

    var kandidaten = [];

    plan.content.querySelectorAll('[data-local]').forEach(function (el) {
      var beginn = startMinute(el.getAttribute('data-t'));
      if (beginn === null) return;
      var versatz = (Number(el.getAttribute('data-d')) - heute + 7) % 7;
      var delta = versatz * 1440 + beginn - jetzt;
      /* Laenger vorbei als LAEUFT heisst: erst in der naechsten Woche wieder. */
      if (delta < -LAEUFT) delta += 10080;
      var hinweis = el.getAttribute('data-n') || '';
      var spiel = el.getAttribute('data-g') || '';
      /* „Keine Locals, offene Tische" ist der Samstag: der heisst nur nach
         seinem Spiel und ist grammatisch Einzahl. */
      var locals = !/keine locals/i.test(hinweis);
      kandidaten.push({
        delta: delta,
        name: locals ? spiel + '-Locals' : spiel,
        mehrzahl: locals,
        ab: pad((beginn / 60) | 0) + ':' + pad(beginn % 60),
        rang: 1
      });
    });

    plan.content.querySelectorAll('[data-event]').forEach(function (el) {
      var ms = Date.parse(el.getAttribute('data-s'));
      if (!isFinite(ms)) return;
      var delta = Math.round((ms - Date.now()) / 60000);
      if (delta < -LAEUFT) return;
      kandidaten.push({
        delta: delta,
        name: el.getAttribute('data-t') || '',
        mehrzahl: false,
        ab: berlinUhr(new Date(ms)),
        rang: 0  /* bei gleichem Zeitpunkt geht der Sondertermin vor */
      });
    });

    if (!kandidaten.length) return;
    kandidaten.sort(function (a, b) { return a.delta - b.delta || a.rang - b.rang; });
    var n = kandidaten[0];
    var tage = Math.floor((jetzt + n.delta) / 1440);
    var text;

    var laeuft = n.mehrzahl ? ' laufen gerade' : ' läuft gerade';
    var startet = n.mehrzahl ? ' starten' : ' startet';

    if (n.delta < 0) text = n.name + laeuft;
    else if (n.delta === 0) text = n.name + startet + ' jetzt';
    else if (n.delta <= BALD) text = n.name + startet + ' in ' + n.delta + (n.delta === 1 ? ' Minute' : ' Minuten');
    else if (tage === 0) text = 'Heute ' + n.ab + ' · ' + n.name;
    else if (tage === 1) text = 'Morgen ' + n.ab + ' · ' + n.name;
    else text = TAGE_LANG[(heute + tage) % 7] + ' ' + n.ab + ' · ' + n.name;

    label.textContent = text;
    link.classList.add('is-live');
  });

  /* --- Bild der Startseite nicht zum Mitnehmen ------------------------
     Kein Kontextmenue und kein Ziehen auf der Szene. Das Bild selbst nimmt
     im CSS keine Zeiger an, dadurch trifft ein Rechtsklick den Rahmen und
     „Bild speichern unter" erscheint gar nicht erst.

     Gegen Entwicklerwerkzeuge, Quelltext oder einen Bildschirmausschnitt
     hilft das nicht — die Adresse der Datei steht im HTML. Das laesst sich
     im Browser nicht abstellen. */
  document.querySelectorAll('[data-schutz]').forEach(function (feld) {
    feld.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    feld.addEventListener('dragstart', function (e) { e.preventDefault(); });
  });

  /* --- Sortierung (Filter-Parameter bleiben erhalten) ---------------- */
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });

  /* --- Feine Pointer-Interaktionen (Desktop) -------------------------- */
  if (!reduce && window.matchMedia('(pointer:fine)').matches) {
    /* magnetische Buttons (folgen leicht dem Cursor) */
    document.querySelectorAll('[data-magnetic]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var mx = e.clientX - (r.left + r.width / 2);
        var my = e.clientY - (r.top + r.height / 2);
        el.style.transform = 'translate(' + (mx * 0.25).toFixed(1) + 'px,' + (my * 0.3).toFixed(1) + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });

    /* Hero-Parallax (nur wenn das Maskottchen sichtbar ist) */
    var px = document.querySelector('[data-parallax]');
    if (px) {
      var art = px.closest('.ph-hero__art') || px.parentElement;
      var hero = px.closest('.ph-hero');
      if (hero && art) {
        hero.addEventListener('pointermove', function (e) {
          var r = hero.getBoundingClientRect();
          var dx = (e.clientX - r.left) / r.width - 0.5;
          var dy = (e.clientY - r.top) / r.height - 0.5;
          art.style.transform = 'translate(' + (dx * 16).toFixed(1) + 'px,' + (dy * 16).toFixed(1) + 'px)';
        }, { passive: true });
        hero.addEventListener('pointerleave', function () { art.style.transform = ''; });
      }
    }
  }
})();
